import { render, staticRenderFns } from "./OsInformDialog.vue?vue&type=template&id=5c4ca35c&scoped=true"
import script from "./OsInformDialog.vue?vue&type=script&lang=ts"
export * from "./OsInformDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ca35c",
  null
  
)

export default component.exports